import React, { useEffect, useState } from "react";
import Layout from "../components/Layout/Layout";
import { PieChart } from "react-minimal-pie-chart";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid,
  InputAdornment,
  ListItemText,
  MenuItem,
  Select,
  SvgIcon,
  Typography,
} from "@mui/material";
import "../css/report.css";
import calendarIco from "../assets/report_calendar.svg";
import LayoutBanner from "../components/Layout/LayoutBanner";
import banner from "../assets/banner_report.svg";
import { useDispatch, useSelector } from "react-redux";
import { downloadPdf, getMetrics, reset } from "../redux/slices/metricSlice";
import { getMonthNumbers } from "../utils/helper";
import download from "../assets/download.svg";
import api from "../Api";
import SimpleSnackbar from "../components/SnackBar/SnackBar";
import calIco from "../assets/calendarIcon.svg";

import Loader from "../components/Loader/Loader";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

// Array of month names
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const currentYear = new Date().getFullYear();
const years = [currentYear];

function CalendarIcon() {
  return <img src={calIco} alt="Date picker opening icon" width={18} />;
}
function DropIcon({ open }) {
  return (
    <>
      {!open ? (
        <SvgIcon>
          <svg
          style={{
            width: "13px",
            marginRight: "15px"
          }}
            width="12"
            height="7"
            viewBox="0 0 12 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.234315 0.234315C0.546734 -0.0781049 1.05327 -0.0781049 1.36569 0.234315L5.8 4.66863L10.2343 0.234315C10.5467 -0.0781049 11.0533 -0.0781049 11.3657 0.234315C11.6781 0.546734 11.6781 1.05327 11.3657 1.36569L5.8 6.93137L0.234315 1.36569C-0.0781049 1.05327 -0.0781049 0.546734 0.234315 0.234315Z"
              fill="black"
            />
          </svg>
        </SvgIcon>
      ) : (
        <SvgIcon sx={{ transform: "rotate(180deg)" }}>
          <svg
           style={{
            width: "13px",
            marginRight: "15px"
          }}
            width="12"
            height="7"
            viewBox="0 0 12 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.234315 0.234315C0.546734 -0.0781049 1.05327 -0.0781049 1.36569 0.234315L5.8 4.66863L10.2343 0.234315C10.5467 -0.0781049 11.0533 -0.0781049 11.3657 0.234315C11.6781 0.546734 11.6781 1.05327 11.3657 1.36569L5.8 6.93137L0.234315 1.36569C-0.0781049 1.05327 -0.0781049 0.546734 0.234315 0.234315Z"
              fill="black"
            />
          </svg>
        </SvgIcon>
      )}
    </>
  );
}
const Report = () => {
  const [selectedYears, setSelectedYears] = React.useState([currentYear]);
  const currentMonth = new Date().toLocaleString("default", { month: "long" });
  const [selectedMonths, setSelectedMonths] = React.useState([currentMonth]);
  const metricData = useSelector((state) => state.metrics.data);
  const [open, setOpen] = React.useState(false);
  const [openOne, setOpenOne] = React.useState(false);
  const metricDataDownloaded = useSelector(
    (state) => state.metrics.downloadCompleted
  );
  const isLoading = useSelector((state) => state.metrics.isLoading);

  const authData = useSelector((state) => state.auth.data);

  const dispatch = useDispatch();

  console.log(metricData);

  useEffect(() => {
    if (metricDataDownloaded) {
      const timer = setTimeout(() => {
        dispatch(reset());
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [metricDataDownloaded, dispatch]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedYears(typeof value === "string" ? value.split(",") : value);
  };
  const handleMonthChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedMonths(typeof value === "string" ? value.split(",") : value);
  };
  const handleView = () => {
    let monthsInNumber = getMonthNumbers(selectedMonths);
    api.defaults.headers.common.Authorization = authData?.access_token
      ? `Bearer ${authData?.access_token}`
      : "";
    dispatch(
      getMetrics(`year=${selectedYears[0]}&months=${monthsInNumber.join(",")}`)
    );
  };
  return (
    <Layout>
      <LayoutBanner
        title={"Metrics"}
        image={banner}
        body={
          "This screen presents a consolidated overview of the records that have been updated and/or added to the SkyPrep database. It allows users to track changes effectively. The information is crucial for monitoring data integrity and ensuring accurate reporting."
        }
      />
      <Loader message={"Loading"} show={isLoading} />

      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          display={"flex"}
          justifyContent={"space-between"}
        >
          <Typography className="heading">Metrics</Typography>
          {metricDataDownloaded && (
            <Alert sx={{ mt: "1rem" }}>Report Downloaded</Alert>
          )}
        </Grid>
        <Grid md={12} mt={2} item>
          <Box
            p={3}
            variant="div"
            display={"flex"}
            className="card"
            justifyContent={"space-between"}
          >
            <Box variant="div" width={"50%"}>
              <Box textAlign={"center"}>
                <img src={calendarIco} alt="calendar_ico" />
                <Typography variant="h6" my={2} fontSize={16} fontWeight={500}>
                  Select the year and month to generate the report
                </Typography>
              </Box>
              <Box variant="div" p={3} width={"70%"} margin={"0 auto"}>
                <FormControl fullWidth>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    multiple
                    value={selectedYears}
                    onChange={handleChange}
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={MenuProps}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={{ background: "#fff" }}
                    startAdornment={
                      <InputAdornment position="start" sx={{ width: "10%" }}>
                        {CalendarIcon()}
                      </InputAdornment>
                    }
                    IconComponent={() => (
                       
                      <DropIcon  open={open}/>
                    )}
                  >
                    {years.map((year) => (
                      <MenuItem key={year} value={year}>
                        <Checkbox checked={selectedYears.includes(year)} />
                        <ListItemText primary={year} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ marginTop: "2rem" }}>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    onOpen={() => setOpenOne(true)}
                    onClose={() => setOpenOne(false)}
                    multiple
                    value={selectedMonths}
                    onChange={handleMonthChange}
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={MenuProps}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={{ background: "#fff" }}
                    startAdornment={
                      <InputAdornment position="start" sx={{ width: "10%" }}>
                        {CalendarIcon()}
                      </InputAdornment>
                    }
                    IconComponent={() => (
                       
                      <DropIcon  open={openOne}/>
                    )}
                  >
                    {months.map((month) => (
                      <MenuItem key={month} value={month}>
                        <Checkbox checked={selectedMonths.includes(month)} />
                        <ListItemText primary={month} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Button
                  variant="contained"
                  sx={{
                    marginTop: "2rem",
                    padding: "5% 0%",
                    background: "#358ad4",
                    fontSize: "16px",
                    "&:hover": {
                      background: "#358ad4da",
                    },
                  }}
                  size="large"
                  fullWidth
                  onClick={handleView}
                  disabled={
                    selectedYears.length == 0 || selectedMonths.length == 0
                  }
                >
                  View
                </Button>
              </Box>
            </Box>
            <Box component={"div"}></Box>
            <>
              <div className="vertical-line" style={{ height: "auto" }}></div>

              <Box width={"50%"} display={"flex"} flexDirection={"column"}>
                <Button
                  onClick={() => {
                    let monthsInNumber = getMonthNumbers(selectedMonths);
                    api.defaults.headers.common.Authorization =
                      authData?.access_token
                        ? `Bearer ${authData?.access_token}`
                        : "";
                    dispatch(
                      downloadPdf(
                        `year=${selectedYears[0]}&months=${monthsInNumber.join(
                          ","
                        )}`
                      )
                    );
                  }}
                  sx={{
                    marginLeft: "auto",
                    color: "#000",
                    fontWeight: "400",
                    borderColor: "#d3d3d3",
                    background: "#fff",
                    fontSize: "16px",
                    "&:hover": {
                      background: "#fff",
                    },
                  }}
                  variant="outlined"
                  disabled={
                    selectedYears.length == 0 || selectedMonths.length == 0
                  }
                >
                  <img
                    src={download}
                    style={{ marginRight: "10px", width: "20px" }}
                  />
                  Download
                </Button>
                {metricData?.createdData?.data?.length > 0 &&
                metricData?.updatedData?.data?.length > 0 ? (
                  <Box variant="div">
                    <Box
                      variant="div"
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={"center"}
                    >
                      <PieChart
                        style={{
                          width: "300px",
                          height: "300px",
                        }}
                        animate={true}
                        labelPosition={50}
                        label={(data) => `${data.dataEntry.value}`}
                        labelStyle={{
                          fontSize: "8px",
                          fill: "#fff",
                        }}
                        data={[
                          {
                            title: "One",
                            value:
                              parseInt(metricData?.createdData?.count) || 0,
                            color: "#33769B",
                          },
                          {
                            title: "Two",
                            value:
                              parseInt(metricData?.updatedData?.count) || 0,
                            color: "#358ad4",
                          },
                        ]}
                      />
                    </Box>
                    <Box
                      variant="div"
                      className="pie_chart"
                      p={2}
                      mt={2}
                      marginX={"auto"}
                      display={"block"}
                    >
                      {/* <Typography fontSize={20} fontWeight={400}>
                    Report Details
                  </Typography> */}
                      <Box
                        variant="div"
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"center"}
                      >
                        <div className="box add"></div>
                        <Typography
                          width={"25%"}
                          fontSize={14}
                          sx={{ color: "#33769B" }}
                        >
                          Students Added
                          <br />
                          {metricData?.createdData?.count || 0}
                        </Typography>
                      </Box>
                      <Box
                        variant="div"
                        display={"flex"}
                        marginTop={"10px"}
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <div className="box update"></div>
                        <Typography
                          width={"25%"}
                          fontSize={14}
                          sx={{ color: "#1E8FCF" }}
                        >
                          Students Updated
                          <br />
                          {metricData?.updatedData?.count || 0}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                ) : (
                  <Box
                    variant="div"
                    display={"flex"}
                    marginTop={"10%"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    height={300}
                  >
                    <Typography fontSize={20}>No Data Found</Typography>
                  </Box>
                )}
              </Box>
            </>
          </Box>
        </Grid>
      </Grid>
    </Layout>
  );
};

export default Report;
